import { SectionToggleState, useFieldValue, useSectionHelper } from "hooks";
import { FormCollapse } from "components/Form";
import React from "react";
import { Section } from "containers/Settings/RuleBooks/Rules/CustomRules/constants";
import { ValueHeader } from "./ValueHeader";
import { ValueForm } from "./ValueForm";

interface ValueSectionProps {
  sectionToggleState: SectionToggleState;
  isMasterRule: boolean;
  parentInputPath: string | null;
  ruleInputPath: string | null;
  showPrerequisiteRuleSource: boolean;
}

export function ValueSection(props: ValueSectionProps) {
  const {
    sectionToggleState,
    parentInputPath,
    ruleInputPath,
    showPrerequisiteRuleSource,
    isMasterRule,
  } = props;
  const { isOpen, onToggle } = useSectionHelper(
    sectionToggleState,
    Section.VALUE,
  );

  const criteria = useFieldValue("criteria");

  const header = <ValueHeader />;
  return (
    <FormCollapse
      isOpen={isOpen}
      onToggle={onToggle}
      header={header}
      dataTour={isOpen ? "hideValue" : "showValue"}
    >
      <ValueForm
        parentInputPath={parentInputPath}
        ruleInputPath={ruleInputPath}
        showPrerequisiteRuleSource={showPrerequisiteRuleSource}
        criteria={criteria}
        isMasterRule={isMasterRule}
      />
    </FormCollapse>
  );
}
